// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__GPv9O","actions":"GroupTable_actions__2Cu_m","deleteModalFooter":"GroupTable_deleteModalFooter__3NUD8"};